/**************************************************
 * Nombre:       Formulario_Producto_Informacion
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoImagenCrop from "../../Modulo_formularios/Componentes/IngresoImagenCrop";
import {useIngresarObjeto} from "../../Modulo_formularios/Hooks/useIngresarObjeto";
import Tarjeta_Informacion from "../Tarjeta/Tarjeta_Informacion";
import Formulario_Informacion_Producto from "./Formulario_Informacion_Producto";


const Formulario_Producto_Informacion = ({...props}) => {
    const {IngresarObjeto} = useIngresarObjeto({
        props: props,
        dato: 'informaciones',
        nombre: 'Agregar Informacion',
        Tarjeta: Tarjeta_Informacion,
        Formulario: Formulario_Informacion_Producto
    })


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Imagen de Guia de Tallas 400px por 400px peso maximo 300kb</Typography>
                </Grid>

                <Grid container size={12}>
                    <IngresoImagenCrop alto={1} ancho={1}
                                       dato={'imgGuia'} {...props}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Informacion Adicional de la prenda</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresarObjeto/>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Producto_Informacion